import { API } from "../../utils/api";
import {
  delteAdminSpotItem,
  delteUserSpotItem,
  getAdminSpotsList,
  getUserSpotsList,
} from "../Reducers/SpotsReducer";

export const getUserSpotsListAction = (data, dispatch) =>
  API.getUserSpots(data).then((res) => {
    if (res.type === "success") {
      dispatch(getUserSpotsList({ items: res.data }));
    }

    return res;
  });

export const deleteUserSpotsListAction = (data, dispatch) =>
  API.deleteUserSpot(data).then((res) => {
    if (res.type === "success") {
      dispatch(delteUserSpotItem({ id: data.id }));
    }

    return res;
  });

export const getAdminSpotsListAction = (data, dispatch) =>
  API.getAdminSpots(data).then((res) => {
    if (res.type === "success") {
      dispatch(getAdminSpotsList({ items: res.data }));
    }

    return res;
  });

export const deleteAdminSpotsListAction = (data, dispatch) =>
  API.deleteAdminSpot(data).then((res) => {
    if (res.type === "success") {
      dispatch(delteAdminSpotItem({ id: data.id }));
    }

    return res;
  });
